import {Component} from 'react'
import propTypes from 'prop-types'

class Droppable extends Component {
  componentDidMount() {
    const {dragLayer} = this.context
    dragLayer.addDropComponent(this)
  }

  componentWillUnmount() {
    const {dragLayer} = this.context
    dragLayer.removeDropComponent(this)
  }

  onDragOver = (e, data) => {
    const {onDragOver} = this.props
    if (onDragOver) onDragOver(e, data)
  }

  onDragOut = (e, data) => {
    const {onDragOut} = this.props
    if (onDragOut) onDragOut(e, data)
  }

  onDrop = (e, data) => {
    const {onDrop} = this.props
    if (onDrop) onDrop(e, data)
  }

  render() {
    const {children} = this.props
    return children
  }
}

Droppable.propTypes = {
  onDrop: propTypes.func.isRequired,  // (e, dragData)
  onDragOver: propTypes.func,         // (e, dragData)
  onDragOut: propTypes.func,          // (e, dragData)
  children: propTypes.element.isRequired,
}

Droppable.contextTypes = {
  dragLayer: propTypes.object.isRequired,
}

export default Droppable
